import React, { useState } from 'react';
import { Box, Text, Button, Input, VStack, useToast, HStack, Container, Image, Heading } from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { careerApi } from './careerApi';

export default function Signup() {
  const nav = useNavigate();
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) return toast({ title: 'Password must be ≥ 8 characters', status: 'warning' });
    setBusy(true);
    try {
      await careerApi.signup({ email, password });
      setSent(true);
    } catch (err) {
      toast({ title: 'Signup failed', description: err.message, status: 'error' });
    }
    setBusy(false);
  }

  if (sent) return (
    <AuthShell title="Check your inbox">
      <Text fontSize="14px" color="#475569" mb="16px" textAlign="center">
        We sent a verification link to <b>{email}</b>. Click it to activate your account.
      </Text>
      <Text fontSize="12px" color="#94A3B8" textAlign="center">
        Didn't get it? Check spam or contact <Text as="a" color="#1E76CE" href="mailto:careers@eoceantechnologies.com">careers@eoceantechnologies.com</Text>.
      </Text>
    </AuthShell>
  );

  return (
    <AuthShell title="Create your account" subtitle="Track your application, get interview invites, and update your profile.">
      <form onSubmit={submit}>
        <VStack spacing="12px" align="stretch">
          <Input placeholder="Email address" size="lg" type="email" required value={email} onChange={e => setEmail(e.target.value)} borderRadius="10px" bg="white" />
          <Input placeholder="Password (≥ 8 characters)" size="lg" type="password" required value={password} onChange={e => setPassword(e.target.value)} borderRadius="10px" bg="white" />
          <Button type="submit" bg="#1E76CE" color="white" _hover={{ bg: '#1A67B4' }} isLoading={busy} size="lg" borderRadius="10px" fontWeight="700">
            Create account
          </Button>
        </VStack>
      </form>
      <HStack justifyContent="center" mt="20px" fontSize="13px" spacing="6px">
        <Text color="#64748B">Already have an account?</Text>
        <Text as={Link} to="/login" color="#1E76CE" fontWeight="700">Log in</Text>
      </HStack>
    </AuthShell>
  );
}

export function AuthShell({ title, subtitle, children }) {
  return (
    <Container maxW="480px" py={{ base: '32px', md: '60px' }}>
      <Box bg="white" borderRadius="18px" p="36px" boxShadow="0 4px 20px rgba(15,23,42,0.05)" border="1px solid #E5E9F0">
        <Box textAlign="center" mb="24px">
          <Image src="/eocean-logo.png" alt="eOcean" h="32px" objectFit="contain" mx="auto" mb="16px" />
          <Heading fontSize="22px" fontWeight="800" color="#0F172A">{title}</Heading>
          {subtitle && <Text fontSize="13px" color="#64748B" mt="6px">{subtitle}</Text>}
        </Box>
        {children}
      </Box>
    </Container>
  );
}
